import Image, { ImageProps } from "next/image"
import React, { useState, useCallback, useRef } from "react"

const CustomImage = ({ src, alt, ...props }: ImageProps) => {
    const fallbackImage = "/svg/v2/pass_ticket_fallback_image_light.png"
    const prevSrcRef = useRef(src)
    const [hasError, setHasError] = useState(false)
    
    // Reset error state only when src actually changes
    if (src !== prevSrcRef.current) {
        prevSrcRef.current = src
        if (hasError) {
            setHasError(false)
        }
    }

    const handleError = useCallback(() => {
        setHasError(true)
    }, [])

    const imgSrc = hasError || !src ? fallbackImage : src

    return (
        <Image
            src={imgSrc}
            alt={alt || "fallback-image"}
            onError={handleError}
            {...props}
        />
    )
}

export default CustomImage
